import React from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

// Lien cliquable vers la fiche native d'un chauffeur ou d'un véhicule.
// type: "driver" -> /conducteurs?focus=<id> ; "vehicle" -> /vehicules?focus=<id>
export function EntityLink({ type, id, children, className, testid }) {
  const navigate = useNavigate();
  const go = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!id) return;
    const path = type === "driver" ? "/conducteurs" : "/vehicules";
    navigate(`${path}?focus=${encodeURIComponent(id)}`);
  };
  if (!id) return <span className={className}>{children}</span>;
  return (
    <button
      type="button"
      onClick={go}
      data-testid={testid}
      className={cn(
        "text-primary/90 hover:text-primary underline-offset-2 hover:underline transition-colors cursor-pointer",
        className
      )}
    >
      {children}
    </button>
  );
}
